function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M335.757,171.931c0-.23-.01-.45-.03-.68l1.86-1.41a1.006,1.006,0,0,0,.26-1.3l-1.87-3.23a.987.987,0,0,0-1.25-.42l-2.15.91a7.588,7.588,0,0,0-1.17-.68l-.29-2.31a1,1,0,0,0-.99-.88H326.4a1,1,0,0,0-1,.88l-.29,2.31a7.587,7.587,0,0,0-1.17.68l-2.15-.91a.987.987,0,0,0-1.25.42l-1.87,3.24a1.008,1.008,0,0,0,.26,1.3l1.86,1.41c-.02.22-.03.44-.03.67s.01.45.03.68l-1.86,1.41a1.006,1.006,0,0,0-.26,1.3l1.87,3.23a.987.987,0,0,0,1.25.42l2.15-.91a7.587,7.587,0,0,0,1.17.68l.29,2.31a1,1,0,0,0,.99.88h3.73a1,1,0,0,0,.99-.88l.29-2.31a7.587,7.587,0,0,0,1.17-.68l2.15.91a.987.987,0,0,0,1.25-.42l1.87-3.23a1.008,1.008,0,0,0-.26-1.3l-1.86-1.41A5.17,5.17,0,0,0,335.757,171.931Zm-7.46,3.5a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,328.3,175.431Z",
  transform: "translate(-316.534 -159.931)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_26",
  "data-name": "Rectangle 26",
  width: 24,
  height: 24,
  fill: "none"
});

function SvgSettingsFocused(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsFocused);
export default __webpack_public_path__ + "static/media/settings_focused.edd9c54c.svg";
export { ForwardRef as ReactComponent };